import React, { useContext } from "react";
import { Legend, XAxis, YAxis, Area } from "recharts";
import { MainLayoutContext } from "../../context/MainLayoutContext";
import { blueGrey } from "@mui/material/colors";
import ChartContainer from "../../components/chart/ChartContainer";

const MarketChart = ({ chartData }) => {
  const { mode } = useContext(MainLayoutContext);

  return (
    <ChartContainer title={chartData.chart_title} data={chartData.history}>
      <XAxis
        dataKey={"x"}
        tickFormatter={(tick) => tick}
        fontSize={".8rem"}
        angle={-25}
        tick={{
          dy: 5,
          fill: mode === "light" ? blueGrey[900] : "#e6e6e6",
        }}
        axisLine={{
          stroke: mode === "light" ? blueGrey[900] : "#fff",
          opacity: "0.5",
        }}
        tickLine={{
          stroke: mode === "light" ? blueGrey[900] : "#fff",
          opacity: "0.5",
        }}
      />
      <YAxis
        type="number"
        tickFormatter={(tick) => new Intl.NumberFormat("fa-IR").format(tick)}
        tick={{
          dx: -30,
          dy: -2,
          fill: mode === "light" ? blueGrey[900] : "#e6e6e6",
        }}
        axisLine={{
          stroke: mode === "light" ? blueGrey[900] : "#fff",
          opacity: "0.5",
        }}
        tickLine={{
          stroke: mode === "light" ? blueGrey[900] : "#fff",
          opacity: "0.5",
        }}
      />
      <Legend verticalAlign="top" />
      <Area
        dataKey="y"
        name={chartData.y_title}
        connectNulls
        type="monotone"
        fill={blueGrey[200]}
        stroke={blueGrey[500]}
      />
    </ChartContainer>
  );
};

export default MarketChart;
